<template>
<v-container fluid class="einstieg">
  <v-row class="d-flex smaller-row-width">
    <v-col>
      <!-- Logo -->
      <v-skeleton-loader
        class="mx-auto"
        type="image"
        width="280"
        tile
      >
        <img class="logo" src="@/assets/images/raab_coaching_inspires_white.svg" width="280" alt="logo-raab-coaching"/>
      </v-skeleton-loader>

      <!-- Contact BTN -->
      <v-btn
        color="transparent"
        width="35"
        fixed
        top
        right
        icon
        rippel="false"
        class="kontakt-btn"
        @click="$vuetify.goTo(scrollTarget, scrollOptions)"
      >

        <img src="@/assets/images/telephone-call-receiver_small.svg" alt="kontakt-btn" width="35" class="kontakt-scroll-btn">
        <span class="kontakt-text" color="#8288a3">Wünschen Sie<br>eine Vertrauliche<br>Beratung?</span>

      </v-btn>
    </v-col>
  </v-row>

  <!-- Content -->
  <v-row>
    <v-col>
      <h1>Unternehmensverkauf <br> ist Vertrauenssache.</h1>
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="12" lg="4" order="2" order-lg="1">
      <p class="text-yellow">
        Sie wollen als Inhaber eines eingeführten, traditionellen Betriebes Verantwortung erfolgreich übergeben?
      </p>
    </v-col>
    <v-col class="max-650" order="1">
      <v-skeleton-loader
        class="mx-auto"
        type="image"
        tile
        max-width="500"
      >
      <v-img
        alt="firma verkaufen"
        contain
        src="@/assets/images/vertrauenssache.jpg"
      />
    </v-skeleton-loader>
    </v-col>
  </v-row>
  <v-row>
    <v-col class="d-none d-lg-flex" cols="4">
    </v-col>
    <v-col class="max-650">
      <div>
        <p>Ihnen ist es wichtig, dass Ihr Lebenswerk in bestmögliche Hände kommt?<br> Dass das Vertrauen Ihrer Kunden und Mitarbeiter gewahrt bleibt? Und nicht zuletzt, dass Ihr bisheriger Lebensmittelpunkt eine faire und auskömmliche Rendite bringt?</p>
        <p>Dann sprechen Sie mit uns. Aufgrund unserer langjährigen Erfahrung verstehen wir die speziellen Interessen <strong>kleinerer und mittlerer Betriebe in handwerksorientierten Branchen.</strong> Wir kennen die Anforderungen sowohl von Verkäufer- als auch Käuferseite.</p>
        <hr>
        <p><strong>Unternehmensverkauf ist Vertrauenssache.</strong> Und ein vielschichtiger Prozess, der Ihnen jederzeit Transparenz und Handlungsfreiheit garantiert.</p>
      </div>
      <ContactBTN />
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import ContactBTN from './ContactBTN.vue'

export default {
  components: {
    ContactBTN
  },

  data () {
    return {
      scrollOptions: {
        duration: 500,
        offset: 0,
        easing: 'easeInOutCubic'
      },
      scrollTarget: '#kontakt'
    }
  }
}
</script>

<style scoped lang="scss">
  .logo {
    width: 280px;
  }

  .kontakt-text {
    color: #8288a3;
    font-size: 0.65rem;
    margin-top: 1em;
  }

  // Spacing to top of html page
  .container {
    padding-top: 3.94rem;
    padding-bottom: 4.44rem;
  }

  // Spacing first headline
  h1 {
    margin-top: 6.66rem;
    margin-bottom: 2.27rem;
  }

  // Contact BTN Styling
  .v-btn--fixed {
    &.v-btn--top {
      top: 3.94rem;
      z-index: 9999;
    }
  }

  .v-btn--fab {
    &.v-btn--contained {
      box-shadow: none;
    }
  }

  @media screen and (min-width: 1920px) {
    .v-btn--fixed {
      &.v-btn--right {
        right: 20%;
      }
    }
  }

  @media screen and (max-width: 1760px) {
    .v-btn--fixed {
      &.v-btn--right {
        right: 10%;
      }
    }
  }

  @media screen and (max-width: 1263px) {
    .container {
      padding-top: 1.5rem;
      padding-bottom: 2.11em;
    }

    .v-btn--fixed {
      &.v-btn--right {
        right: 5%;
      }
    }

    h1 {
      margin-left: 0;
      margin-top: 3.33rem;
    }

    p {
      &.text-blue {
        margin-bottom: 0;
      }
    }

    // Contact BTN Styling
    .v-btn--fixed {
      &.v-btn--top {
        top: 45px;
        right: 13%;
        z-index: 9999;
      }
    }
  }

  @media screen and (max-width: 600px) {
    h1 {
      margin-top: 1rem;
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 380px){
    .logo {
      width: 205px;
    }

    .v-btn--fixed {
      &.v-btn--right {
        right: 13%;
        top: 45px;
      }
    }
  }

  @media screen and (max-width: 350px) {
    h1 {
      font-size: 1.25rem;
    }
  }
</style>
